import React from "react";
import Icons from "../../assets/icons/icons.svg";

const Icon: React.FC<{bgColor?: string; className?: string; name: string; color?: string; size?: number }>  = ({bgColor, className, name, color, size }) => (
  <svg color={bgColor} style={{backgroundColor: bgColor}} className={`${className ?? ''} icon icon-${name}`} fill={color} width={size} height={size}>
    <use xlinkHref={`${Icons}#icon-${name}`} />
  </svg>
);

export default Icon;